import React, { useState } from 'react';
import { useWallets } from '../WalletContext';
import './MobileHeader.css';

function MobileHeader() {
  const { wallets, selectedWallets, handleWalletToggle, getSelectedWalletsDisplay, getCurrencySymbol } = useWallets();
  const [showWalletMenu, setShowWalletMenu] = useState(false);

  // Filter out "All Pots" option (id=0)
  const selectableWallets = wallets.filter(w => w.id !== 0);

  const isSelected = (walletId) => selectedWallets.includes(walletId);

  const handleWalletClick = (walletId) => {
    handleWalletToggle(walletId);
  };

  // Get current pot currency symbol
  const getCurrentCurrency = () => {
    if (selectedWallets.length === 0) return '€';
    const wallet = selectableWallets.find(w => w.id === selectedWallets[0]);
    return wallet ? getCurrencySymbol(wallet.currency) : '€';
  };

  return (
    <>
      <header className="mobile-header">
        <div className="mobile-header-left">
          <span className="mobile-logo">🏠</span>
          <span className="mobile-title">DomusAI</span>
        </div>
        
        <button 
          className="wallet-toggle-btn"
          onClick={() => setShowWalletMenu(!showWalletMenu)}
        >
          <span className="wallet-btn-icon">🫙</span>
          <span className="wallet-btn-text">{getSelectedWalletsDisplay()}</span>
          <span className={`wallet-btn-arrow ${showWalletMenu ? 'open' : ''}`}>▾</span>
        </button>
      </header>

      {/* Pot Selection Menu */}
      {showWalletMenu && (
        <>
          <div className="wallet-menu-overlay" onClick={() => setShowWalletMenu(false)} />
          <div className="wallet-menu">
            <div className="wallet-menu-header">
              <span>Select Pots</span>
              <button className="wallet-menu-close" onClick={() => setShowWalletMenu(false)}>✕</button>
            </div>
            
            {selectableWallets.length === 0 ? (
              <div className="wallet-menu-empty">
                <span>🫙</span>
                <p>No pots yet</p>
                <small>Create one in Settings</small>
              </div>
            ) : (
              <div className="wallet-menu-list">
                {selectableWallets.map(wallet => (
                  <button 
                    key={wallet.id}
                    className={`wallet-menu-item ${isSelected(wallet.id) ? 'selected' : ''}`}
                    onClick={() => handleWalletClick(wallet.id)}
                  >
                    <span className="wallet-item-check">
                      {isSelected(wallet.id) ? '✓' : ''}
                    </span>
                    <span className="wallet-item-icon">{wallet.icon || '🫙'}</span>
                    <div className="wallet-item-info">
                      <span className="wallet-item-name">{wallet.name}</span>
                      <span className="wallet-item-currency">{getCurrencySymbol(wallet.currency)} {wallet.currency}</span>
                    </div>
                    <span className="wallet-item-balance">
                      {getCurrencySymbol(wallet.currency)}{Number(wallet.balance || 0).toFixed(0)}
                    </span>
                  </button>
                ))}
              </div>
            )}
            
            <div className="wallet-menu-hint">
              💡 Tap to select/deselect pots
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default MobileHeader;
